module.exports = __webpack_public_path__ + "static/media/pixeled-box-purple.274aeb2b.svg";